module.exports = __webpack_public_path__ + "static/media/che1.e96590e4.png";